export default __webpack_public_path__ + "static/business_3-375fc497ae971fbf1aef9e056c67400d.jpg";